import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Utils from '../../../../common/utils';

export default {
	getSessionUUID() {
		return Utils.getContextId(uuidv4);
	},

	getHeaders() {
		return {
			'x-correlation-id': uuidv4(),
			'x-request-id': uuidv4()
		};
	},

	apiConfig() {
		const headers = this.getHeaders();
		const assetId = sessionStorage.getItem('osAssetId');
		if (assetId) {
			headers['x-asset-id'] = assetId;
		}
		return axios.get('/search/api/config', { headers });
	},

	detailedSearch(query, from, size, segments, recaptchaToken) {
		const params = {
			query: query,
			from: from,
			size: size,
			domains: segments,
			labels: 'gyik'
		};
		const headers = this.getHeaders();
		if (recaptchaToken) {
			headers['x-recaptcha-token'] = recaptchaToken;
		}
		const assetId = sessionStorage.getItem('osAssetId');
		if (assetId) {
			headers['x-asset-id'] = assetId;
		}
		return axios.get('/search/api/search/detailed-search', { params, headers });
	}
};
